import React, { useContext } from 'react';
import { NavLink } from 'react-router-dom';
import { ListItem, ListItemIcon, ListItemText } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import styled, { css } from 'styled-components';
import { LayoutUIContex } from '../Layout/LayoutUIContext';

const Item = styled(ListItem)`
    && {
        border-radius: 8px;
        margin: 2px 8px;
        overflow: hidden;
        min-height: 40px;
        align-items: center;
        transition: padding .12s ease, justify-content .12s ease;
    }
    &.MuiListItem-button:hover {
        background: rgba(255,255,255,.06);
    }
    &.active {
        background: rgba(255,255,255,.08);
        color: #e5e7eb;
        box-shadow: inset 3px 0 0 0 #6366f1;
    }
`;

const ItemIcon = styled(ListItemIcon)`
    min-width: 36px;
    & svg { color: #94a3b8; }
    ${Item}.active & svg { color: #e5e7eb; }
`;

const ItemText = styled(ListItemText)`
    transition: opacity .12s ease;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    min-width: 0;
`;

export default function NavItem({
                                    to, onClick, icon, label, exact, isActive,
                                }) {
    const theme = useTheme();
    const hasRoute = Boolean(to);

    const handleClick = (e) => {
        if (!hasRoute) {
            e.preventDefault();
            if (typeof onClick === 'function') onClick(e);
        }
    };

    const listItemProps = {
        button: true,
        onClick: handleClick,
    };

    if (hasRoute) {
        return (
            <Item
                {...listItemProps}
                component={NavLink}
                to={to}
                exact={exact}
                isActive={isActive}
                activeClassName="active"
            >
                <ItemIcon>{icon}</ItemIcon>
                <ItemText primary={label} primaryTypographyProps={{ noWrap: true }} />
            </Item>
        );
    }

    return (
        <Item
            {...listItemProps}
            $padX={theme.spacing(2)}
            $nested={nested}
        >
            <ItemIcon>{icon}</ItemIcon>
            <ItemText primary={label} primaryTypographyProps={{ noWrap: true }} />
        </Item>
    );
}
